import _ from 'lodash';
import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { useKey } from '@jvs-group/jvs-mairistem-tools';
import Input from "../Input";
import { getRest } from "../../utils";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Collection List Field.
 */
var CollectionListField = function CollectionListField(props) {
  var defaultValue = props.defaultValue,
    defaultEditing = props.defaultEditing,
    asModification = props.asModification,
    onEditingChange = props.onEditingChange;

  /** In editing state. */
  var _useState = useState(false),
    editing = _useState[0],
    setEditing = _useState[1];

  /** Value of the default input. */
  var _useState2 = useState(''),
    value = _useState2[0],
    setValue = _useState2[1];
  var timeout = useRef(null);
  var inputRef = useRef(null);
  useEffect(function () {
    setEditing(defaultEditing);
    setValue(defaultValue);
  }, []);
  useEffect(function () {
    if (!_.isNil(asModification)) {
      if (editing !== defaultEditing && value !== defaultValue) {
        setEditing(defaultEditing);
        setValue(defaultValue);
        _.invoke(props, 'onEditingChange', defaultEditing);
      }
      if (editing !== defaultEditing) {
        setEditing(defaultEditing);
        _.invoke(props, 'onEditingChange', defaultEditing);
      }
      if (value !== defaultValue) {
        setValue(defaultValue);
      }
    }
  }, [asModification, editing, defaultEditing, value, defaultValue, onEditingChange]);
  useEffect(function () {
    return function () {
      if (!_.isNil(timeout.current)) {
        clearTimeout(timeout.current);
      }
    };
  }, [timeout]);

  /**
   * Handle input's focus.
   */
  var handleFocus = function handleFocus(event, data) {
    setEditing(true);
    if (!_.isNil(inputRef.current)) {
      inputRef.current.focus();
    }
    _.invoke(props, 'onFocus', event, data);
    _.invoke(props, 'onEditingChange', true);
  };

  /** Handle input's blur. */
  var handleBlur = function handleBlur(event) {
    if (!_.isNil(timeout.current)) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(function () {
      setEditing(false);
      _.invoke(props, 'onBlur', event, value);
      _.invoke(props, 'onEditingChange', false);
    }, 200);
  };

  /**
   * Handle blur for the asModification component.
   */
  var handleAsModificationBlur = function handleAsModificationBlur(event, data) {
    if (!_.isNil(timeout.current)) {
      clearTimeout(timeout.current);
    }
    timeout.current = setTimeout(function () {
      setEditing(false);
      _.invoke(props, 'onBlur', event, data);
      _.invoke(props, 'onEditingChange', false);
    }, 200);
  };

  /**
   * Handle the click on the visualisation component.
   */
  var handleAsVisualisationClick = function handleAsVisualisationClick(event, data) {
    setEditing(true);
    _.invoke(props, 'onClick', event, data);
    _.invoke(props, 'onEditingChange', true);
  };

  /**
   * Handle cancel click.
   */
  var handleCancelClick = function handleCancelClick() {
    setEditing(false);
    setValue(defaultValue);
    if (!_.isNil(timeout.current)) {
      clearTimeout(timeout.current);
    }
    _.invoke(props, 'onCancelClick');
    _.invoke(props, 'onEditingChange', false);
  };

  /**
   * Handler for input change.
   */
  var handleChange = function handleChange(event, data) {
    setValue(data.value);
    _.invoke(props, 'onChange', event, data);
  };

  /**
   * Handler for input key down.
   */
  var handleModificationKeyDown = function handleModificationKeyDown(event) {
    if (event.key === 'Enter') {
      handleBlur(event);
    } else if (event.key === 'Escape') {
      handleCancelClick();
    }
  };

  /**
   * Handle input ref for focus.
   */
  var handleRef = function handleRef(node) {
    inputRef.current = node;
  };

  /** Render the component. */
  var render = function render() {
    var children = props.children,
      className = props.className,
      asVisualisation = props.asVisualisation;
    var rest = getRest(CollectionListField, props);
    var classes = classNames(useKey(!editing, 'editable'), className);
    if (!(_.isNil(children) || _.isEmpty(children))) {
      return children;
    }
    if (editing) {
      // Gestion de l'élément de modification s'il y a
      if (!_.isNil(asModification)) {
        return /*#__PURE__*/React.createElement(asModification, Object.assign({
          className: classes
        }, rest, {
          defaultValue: defaultValue,
          // si jamais c'est une dropdown
          onBlur: handleAsModificationBlur,
          onChange: handleChange
        }));
      }
      return /*#__PURE__*/_jsx(Input, Object.assign({}, rest, {
        fluid: true // obligatoire sinon déborde si placé dans une Grid.Column
        ,
        className: classes,
        input: {
          ref: handleRef
        },
        onBlur: handleBlur,
        onChange: handleChange,
        onKeyDown: handleModificationKeyDown,
        value: value,
        icon: {
          name: 'cancel',
          link: true,
          onClick: handleCancelClick
        }
      }));
    }

    // Gestion de l'élément de visualisation s'il y a
    if (!_.isNil(asVisualisation)) {
      return /*#__PURE__*/React.createElement(asVisualisation, Object.assign({
        className: classes
      }, rest, {
        onClick: handleAsVisualisationClick,
        onFocus: handleFocus
      }));
    }
    return /*#__PURE__*/_jsx("span", {
      className: classes,
      role: "button",
      tabIndex: 0,
      onClick: handleFocus,
      onFocus: handleFocus,
      onKeyDown: handleFocus,
      children: value
    });
  };
  render.handledProps = [];
  return render();
};

/**
 * Default props.
 */
CollectionListField.handledProps = ["defaultEditing", "defaultValue"];
CollectionListField.defaultProps = {
  defaultEditing: false,
  defaultValue: ''
};
export default CollectionListField;